var activeSnake = 0;
var animTime = 200;

(function($) {

	if ($('.mini-services').length) {
		$('.mini-service').on('mouseenter click',function(){
			var service = $(this);
			if (!service.hasClass('active')) {
				$('.mini-service').removeClass('active');
				service.addClass('active');
				var index = service.parent().find('.mini-service').index(service);
				if ($(window).outerWidth() < 640) {
					var newBot = 0.5 + (75 - (index * 25)) + '%';
					$('.mini-services__header__selector').css('bottom',newBot);
				} else {
					var newLeft = $(window).outerWidth() < 1024 ? 1 + (index*25) + '%' : 4 + (index*25) + '%';
					$('.mini-services__header__selector').css('left',newLeft);
				}
				$('.mini-services__details').stop().slideUp().eq(index).slideDown();				
				
				activeSnake = index;
				snakes(index,service);
			}
		});

		// prevent mini service header items from triggering links on mobile
		$('.mini-service').on('click',function(e){
			if (window.matchMedia("(pointer: coarse)").matches) {
				e.preventDefault();
				var winHeight = $(window).outerHeight();
				$('html, body').stop().animate({
	                scrollTop: $('.circles').offset().top + $('.circles').outerHeight() - winHeight
	            });
			}
		});

		function addSnake(index) {			
			$('.mini-services').append('<div class="service-snake service-snake--'+index+' new"></div>');
			$('.service-snake').not('.service-snake--'+activeSnake).remove();
		}

		function snakes(index,service) {
			$('.service-snake').remove();	
			var windowW 	= $(window).outerWidth();	
			var serviceHalf = service.outerWidth()/2;
			var snakeLeft 	= service.position().left+serviceHalf+20;
			var snakeRight 	= service.parent().outerWidth() - (service.position().left+serviceHalf+20);
			var snakeOutR	= service.parent().outerWidth() - ($('.mini-service').eq(0).position().left+serviceHalf+20);
			var snakeTop 	= service.position().top+service.outerHeight();
			var downStem	= windowW < 1024 ? 170 : 210;
			var downStemSM	= windowW < 1024 ? 50 : 70;
			var snakeW = windowW < 1024 ? 100 : 160;
			var snakeH = 240;
			if (index==0) {
				addSnake(index);
				$('.service-snake.new').removeClass('new').css({ left:snakeLeft, top:snakeTop })
					.animate({
						height: downStem
					},animTime+100,function(){
						addSnake(index);
						$('.service-snake.new')
							$('.service-snake.new').removeClass('new').css({ left:snakeLeft, top:snakeTop+downStem-10 })
							.animate({
								width: snakeW
							},animTime,function(){
								addSnake(index);
								$('.service-snake.new')
									$('.service-snake.new').removeClass('new').css({ left:snakeRight-snakeW, top:snakeTop+downStem-10 })
									.animate({
										width: snakeW
									},animTime,function(){
										addSnake(index);
										$('.service-snake.new')
											$('.service-snake.new').removeClass('new').css({ left:snakeRight-10, top:snakeTop+downStem-10 })
											.animate({
												height: snakeH
											},animTime+100,function(){
												
											})
									})
							})
					});
			}
			if (index==1) {
				addSnake(index);
				$('.service-snake.new').removeClass('new').css({ left:snakeLeft, top:snakeTop })
					.animate({
						height: downStemSM
					},animTime,function(){
						addSnake(index);
						$('.service-snake.new')
							$('.service-snake.new').removeClass('new').css({ left:snakeOutR-snakeW, top:snakeTop+downStem-10 })
							.animate({
								width: snakeW
							},animTime,function(){
								addSnake(index);
								$('.service-snake.new')
									$('.service-snake.new').removeClass('new').css({ left:snakeOutR-10, top:snakeTop+downStem-10 })
									.animate({
										height: snakeH
									},animTime+100,function(){
										
									})
							})
					})
			}
			if (index==2) {
				addSnake(index);
				$('.service-snake.new').removeClass('new').css({ left:snakeLeft, top:snakeTop })
					.animate({
						height: downStemSM
					},animTime,function(){
						addSnake(index);
						$('.service-snake.new')
							$('.service-snake.new').removeClass('new').css({ right:snakeOutR-snakeW, top:snakeTop+downStem-10 })
							.animate({
								width: snakeW
							},animTime,function(){
								addSnake(index);
								$('.service-snake.new')
									$('.service-snake.new').removeClass('new').css({ right:snakeOutR-10, top:snakeTop+downStem-10 })
									.animate({
										height: snakeH
									},animTime+100,function(){
										
									})
							})
					})
			}
			if (index==3) {
				addSnake(index);
				$('.service-snake.new').removeClass('new').css({ right:snakeRight, top:snakeTop })
					.animate({
						height: downStem
					},animTime+100,function(){
						addSnake(index);
						$('.service-snake.new')
							$('.service-snake.new').removeClass('new').css({ right:snakeRight, top:snakeTop+downStem-10 })
							.animate({
								width: snakeW
							},animTime,function(){
								addSnake(index);
								$('.service-snake.new')
									$('.service-snake.new').removeClass('new').css({ right:snakeLeft-snakeW, top:snakeTop+downStem-10 })
									.animate({
										width: snakeW
									},animTime,function(){
										addSnake(index);
										$('.service-snake.new')
											$('.service-snake.new').removeClass('new').css({ right:snakeLeft-10, top:snakeTop+downStem-10 })
											.animate({
												height: snakeH
											},animTime+100,function(){
												
											})
									})
							})
					});
			}
		}
	}

})( jQuery );  